import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  AuthService,
  FilesService,
  OrderService,
  OrderInfo,
  CloudService,
  FileAccessMode,
} from "app/shared";
import { SystemService } from "app/shared/system.service";
import { CuttingService, CuttingData } from "cutting/cutting.service";
import { NewProjectSettings, ProjectHandler } from "modeler/project-handler";
import { concatMap, tap, map, combineLatest, of } from "rxjs";

@Component({
  selector: "app-cutting-home",
  templateUrl: "./cutting-home.component.html",
})
export class CuttingHomeComponent implements OnInit {
  defaults: NewProjectSettings;

  constructor(
    public cuttingService: CuttingService,
    private system: SystemService,
    private authService: AuthService,
    private files: FilesService,
    private orderService: OrderService,
    private cloudService: CloudService,
    private router: ActivatedRoute
  ) {
    this.system.getSettings(NewProjectSettings).subscribe((defaults) => {
      this.defaults = defaults;
    });
  }

  ngOnInit() {
    var cuttingDataBase64URL = this.router.snapshot.queryParams["cuttingData"];
    var cuttingData = this.cuttingService.decodeLink(cuttingDataBase64URL);
    if (cuttingData && cuttingData.refreshToken) {
      this.authService
        .loginByToken(cuttingData.refreshToken)
        .pipe(
          map((result) => {
            if (result) {
              if (cuttingData.id)
                return this.updateOrder(cuttingData.id, cuttingData);
              else return this.newOrder(cuttingData);
            }
          }),
          concatMap((order) => order),
          tap((order) => this.cuttingService.goToProject(order.id))
        )
        .subscribe();
    }
  }

  linkWithCloudOrder(id: number, cloudOrderId: number) {
    return this.cloudService.LinkCloudOrder(cloudOrderId, id);
  }

  updateOrder(id: number, cuttingData: CuttingData) {
    let order: OrderInfo = {
      id: id,
      name: cuttingData.orderName,
      client: {
        name: cuttingData.client.name,
        address: cuttingData.client.address,
        email: cuttingData.client.email,
        phone: cuttingData.client.phone,
      },
    };

    return this.files.getFileAccess(id)
      .pipe(concatMap(
        (access) => {
          if (access.access !== FileAccessMode.Write) {
            return of(order);
          } else {
            return this.orderService.setOrder(order.id, order)
          }
        }
      ));
  }

  newOrder(cuttingData: CuttingData) {
    let command = ProjectHandler.createNewProject(this.defaults);
    return this.files
      .createProject(
        cuttingData.orderName,
        command,
        undefined,
        cuttingData.cloudOrderId
      )
      .pipe(
        concatMap((file) =>
          combineLatest([
            this.linkWithCloudOrder(file.id, cuttingData.cloudOrderId),
            this.updateOrder(file.id, cuttingData),
          ]).pipe(map(([_, res]) => res))
        )
      );
  }
}
